// Georgian Physical Order Payment specific data configuration

const STATUS_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'PENDING', label: 'Pending' },
  { value: 'COMPLETED', label: 'Completed' },
  { value: 'REJECTED', label: 'Rejected' },
  { value: 'REFUNDED', label: 'Refunded' },
];

const TABLE_HEAD = [
  { id: 'trackingNumbers', label: 'Tracking Numbers', width: 200 },
  { id: 'totalWeight', label: 'Total Weight (kg)', width: 140 },
  { id: 'pickup_area', label: 'Pickup Area', width: 140 },
  { id: 'pickup_price', label: 'Pickup Price', width: 120 },
  { id: 'promotion', label: 'Promotion', width: 120 },
  { id: 'totalUSD', label: 'Total (USD)', width: 120 },
  { id: 'totalGel', label: 'Total (GEL)', width: 120 },
  { id: 'payed_by', label: 'Paid By', width: 120 },
  { id: 'paymentMethod', label: 'Payment Method', width: 160 },
  { id: 'deliveryExtraMethod', label: 'Delivery Method', width: 140 },
  { id: 'deliveryGEL', label: 'Delivery (GEL)', width: 140 },
  { id: 'deliveryUSD', label: 'Delivery (USD)', width: 140 },
  { id: 'payed', label: 'Payment Status', width: 140 },
  { id: 'createdAt', label: 'Created Date', width: 160 },
  { id: 'updatedAt', label: 'Updated Date', width: 160 },
  { id: '', width: 88 },
];

const defaultFilters = {
  role: [],
  payment_status: [],
  payment_method: [],
  payedBy: [],
  paymentMethods: [],
};

const tableNames = [
  { id: 'id', label: 'Group ID' },
  { id: 'trackingNumbers', label: 'Tracking Numbers' },
  { id: 'totalWeight', label: 'Total Weight (kg)' },
  { id: 'totalUSD', label: 'Total (USD)' },
  { id: 'totalGel', label: 'Total (GEL)' },
  { id: 'payed_by', label: 'Payment Method' },
  { id: 'payed', label: 'Payment Status' },
  { id: 'createdAt', label: 'Created Date' },
];

const paymentStatus = [
  { value: 'all', label: 'All' },
  { value: true, label: 'Paid' },
  { value: false, label: 'Unpaid' },
];

const paymentMethods = [
  { value: 'all', label: 'All' },
  { value: 'USD', label: 'USD' },
  { value: 'GEL', label: 'GEL' },
];

const payedByOptions = [
  { value: 'all', label: 'All' },
  { value: 'USD', label: 'USD' },
  { value: 'GEL', label: 'GEL' },
];

const paymentMethodOptions = [
  { value: 'all', label: 'All' },
  { value: 'CASH', label: 'Cash' },
  { value: 'STRIPE_LINK', label: 'Stripe Link' },
  { value: 'STRIPE_TERMINAL', label: 'Stripe Terminal' },
  { value: 'BOG_TERMINAL', label: 'BOG Terminal' },
  { value: 'BANK_TRANSFER', label: 'Bank Transfer' },
  { value: 'CHECK', label: 'Check' },
];

const personalInformation = [
  {
    name: 'group_id',
    width: '96%',
    label: 'Group ID',
  },
  {
    name: 'tracking_numbers',
    width: '96%',
    label: 'Tracking Numbers',
  },
  {
    name: 'customer_room_number',
    width: '96%',
    label: 'Room Number',
  },
  {
    name: 'total_weight',
    width: '96%',
    label: 'Total Weight (kg)',
  },
  {
    name: 'total_usd',
    width: '96%',
    label: 'Total (USD)',
  },
  {
    name: 'total_gel',
    width: '96%',
    label: 'Total (GEL)',
  },
  {
    name: 'payment_method',
    width: '96%',
    label: 'Payment Method',
  },
  {
    name: 'payment_status',
    width: '96%',
    label: 'Payment Status',
  },
];

const status_colors = {
  PENDING: ['#FFAB0029', '#B76E00'],
  COMPLETED: ['#22C55E29', '#118D57'],
  REJECTED: ['#FF563029', '#B71D18'],
  REFUNDED: ['#919EAB29', '#637381'],
};

export {
  STATUS_OPTIONS,
  TABLE_HEAD,
  defaultFilters,
  tableNames,
  paymentStatus,
  paymentMethods,
  payedByOptions,
  paymentMethodOptions,
  personalInformation,
  status_colors,
};
